import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

class PlyrElement extends HTMLElement {
  constructor() {
    super()

    this.player = new Plyr(
      this.querySelector('video'),
      {
        controls: ['play-large', 'play', 'progress', 'mute'],
        ratio: this.dataset.ratio,
      }
    );
  }
}

if (!customElements.get("plyr-element"))
  customElements.define("plyr-element", PlyrElement)
